import { AirPort, iChatData } from "../../../types";

export function extractFlightSegments(selectedChatData: iChatData, shouldUsenewAirportSearch: boolean) {
  const flights: AirPort[] = [];

  if (!selectedChatData?.destinationList) return [];

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const normalizeDate = (d: string) => new Date(d + "T00:00:00");

  let globalHasFlight = false;

  // Source of truth for the departure-time chip is the user's actual preference
  // (trip_preferences.flights.time_of_day, surfaced as selectedChatData.flight_day_part).
  // Do NOT fall back to the activity's time_of_the_day — that is a required display slot
  // on the itinerary card, not a user preference.
  const userDaypartPreference = selectedChatData?.flight_day_part || "";

  selectedChatData.destinationList.forEach((destination) => {
    destination.tripDetails?.forEach((tripDetail) => {
      const { itinerary_by_time_of_the_day_data = [], date, day } = tripDetail;

      let validDate = "";
      if (date) {
        const parsed = normalizeDate(date);
        parsed.setHours(0, 0, 0, 0);
        if (parsed >= today) validDate = date;
      }

      itinerary_by_time_of_the_day_data.forEach((activity: any) => {
        const isFlight =
          activity?.type === "transportation.flight" || activity?.activity_type === "transportation.flight";

        if (isFlight) {
          globalHasFlight = true;

          const {
            departure_city_name,
            departure_city_state,
            departure_city_country,
            arrival_city_name,
            arrival_city_state,
            arrival_city_country,
          } = activity;

          const departureAddress = shouldUsenewAirportSearch
            ? departure_city_name
            : `${departure_city_name}, ${departure_city_state}, ${departure_city_country}`;
          const arrivalAddress = shouldUsenewAirportSearch
            ? arrival_city_name
            : `${arrival_city_name}, ${arrival_city_state}, ${arrival_city_country}`;

          flights.push({
            departureTimeInSlider: getTimeRange(userDaypartPreference),
            flightDepartureTime: userDaypartPreference,
            returnTime: "",
            isSelected: true,
            arrivalAddress,
            departureAddress,
            arrivalCityAddress: arrivalAddress,
            arrival: "",
            departure: "",
            departureDate: validDate,
            returnDate: validDate,
            departureAirportFullName: "",
            arrivalAirportFullName: "",
            noOfDays: day?.replace("Day ", "") || "",
          });
        }
      });
    });
  });

  if (!globalHasFlight) {
    return [
      {
        departureTimeInSlider: [],
        flightDepartureTime: "",
        returnTime: "",
        isSelected: true,
        arrivalAddress: "",
        departureAddress: "",
        arrivalCityAddress: "",
        arrival: "",
        departure: "",
        departureDate: "",
        returnDate: "",
        departureAirportFullName: "",
        arrivalAirportFullName: "",
        noOfDays: 1,
      },
    ];
  }
  return flights;
}

const timeRanges = {
  "Early morning": [0, 4],
  Morning: [5, 11],
  Afternoon: [12, 16],
  Evening: [17, 20],
  Night: [21, 23],
} as const;

type TimeRangeKey = keyof typeof timeRanges;

// Build lowercase lookup map
const lowerCaseMap: Record<string, TimeRangeKey> = Object.keys(timeRanges).reduce(
  (acc, key) => {
    acc[key.toLowerCase()] = key as TimeRangeKey;
    return acc;
  },
  {} as Record<string, TimeRangeKey>
);

export function getTimeRange(value?: string): number[] {
  if (!value) return []; // empty, null, undefined

  const normalized = value.toLowerCase();
  const key = lowerCaseMap[normalized];

  if (!key) return []; // invalid format

  return [...timeRanges[key]];
}
